import { useCompanion } from "@hooks/use-companion";

export const CompanionChatInputSection = () => {
  const { companionSession } = useCompanion();

  if (!companionSession?.companionSessionUuid) {
    return null;
  }

  return (
    <div className="flex flex-col items-center gap-2 rounded-lg bg-gray-100 p-3 text-center dark:bg-gray-700/50">
      <p className="text-sm text-gray-500 dark:text-gray-400">
        This is a legacy Companion chat. New messages can&apos;t be
        sent here.
      </p>
    </div>
  );
};
